<template>
    <section class="head-section">
<!--   :poster="videoPreview && require(`@/assets/preview/${videoPreview}.jpg`) || false" @load="videoIsReady = true"     -->
        <video class="head-section__img"
               :src="video"
               autoplay muted playsinline
               loop="loop"
               v-if="video"
               ref="video"
        ></video>
        <div v-else style="position: relative; width: 100%">
            <img class="head-section__img" :src="getImg" :alt="data.img">
            <slot></slot>
        </div>
        <slot name="button"></slot>
        <ButtonBookDemo style="opacity: 0.7" class="book-a-demo" v-if="!$slots?.button"/>
    </section>
</template>
<script>

export default {
    name: "HeadSectionMain",
    props:{
        srcImg: String,
        data: {
            type: [Object,Array],
            default: () => { return {} }
        }
    },
    data(){
        return {
            videoIsReady: false,
        }
    },
    components:{
    },
    computed:{
        roteName() {
            return this.$route?.name
        },
        lang(){
            return this.$i18n.locale
        },
        title(){
            return  this.data?.title[this.lang]
        },
        description(){
            return  this.data?.description[this.lang]
        },
        video() {
            return this.data?.video
        },
        videoPreview() {
            return this.data?.videoPreview
        },
        watchUpdate() {
          return [!!this.video, this.videoIsReady].join(',')
        },
        getImg() {
            let img = this.data.img;
            let pathImg = this.data?.pathImg || this.srcImg || 'products/';
            return require('@/assets/'+pathImg+img+'.png');
        }
    },
    watch: {
        watchUpdate: {
            handler: function () {
                if(this.video && this.videoIsReady) {
                    this.play()
                }
            },
            immutable: true
        },
    },
    methods: {
        play() {
            // if(!this.$refs.video.paused && !this.$refs.video.ended) {
                this.$refs?.video?.play()
            // }
            // console.log('no')
        }
    },
    mounted() {
        // if(this.video) {
        //     this.play()
        // }
        // document.addEventListener("DOMContentLoaded", this.play);
    },
    beforeUnmount() {
        // document.removeEventListener('DOMContentLoaded', this.play)
    }
}
</script>

<style scoped lang="scss">
video::-webkit-media-controls {
    display:none !important;
}
.head-section {
    position: relative;
    height: 100%;
    max-height: calc(100vh - 95px);
    overflow: hidden;
    display: flex;
    &.fill-height {
        height: calc(100vh - 95px);
    }
    &__img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
    .button-default {
        position: absolute;
        bottom: 100px;
        left: 50%;
        transform: translateX(-50%);
    }
}
.dealer-header {
    height: auto;
    max-height: 550px;
    position: relative;
    .head-section__img {
        object-fit: cover;
    }
}
@media all and (max-width: 650px) {
    .head-section {
        .button-default {
            bottom: 20px;
        }
    }
}
@media screen and (max-width: 1080px) {
    .dealer-header {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .book-a-demo {
            margin-top: 20px;
            transform: none;
            position: static;
        }
    }
}
</style>